import React from 'react'
import Layout from 'features/layout/components/Layout'
import StaticPageForm from '../components/StaticPageForm'

const StaticPageFormPage = (props) => {
  return (
    <Layout>
      <StaticPageForm />
    </Layout>
  )
}

export default StaticPageFormPage
